<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.employee.editStaff')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <back-button></back-button>

                <!-- <b-alert v-model="disableEditForm" variant="info">{{disableEditFormMessage}}</b-alert> -->

                 <b-alert v-model="showDisableAlert"  variant="info"> {{disableEditFormMessage}}
                    <button v-if="!firstLoad && sessionCreated" @click="checkForEdit(true)">
                         <i class="fas fa-sync"></i>
                    </button>
                </b-alert>

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                        <div class="card-header bg-light">
                            <div class="card-title">{{$t('form.employee.editStaff')}}</div>

                            <div class="text-right">
                                <button class="btn btn-primary" @click="updateStaff()"
                                    :disabled="disableEditForm || readonly">{{$t('button.update')}}</button>
                                <button class="btn btn-info" @click="updateStaff(true)"
                                    :disabled="disableEditForm || readonly">{{$t('button.updateClose')}}</button>
                            </div>
                        </div>

                        <div class="card-body">
                            <b-tabs content-class="mt-3">
                                <b-tab :title="$t('form.employee.tabPersonal')" active>
                                    <div class="row">

                                        <div class="col-md-3 col-sm-4">
                                            <div class="form-group">
                                                <h3>{{$t('form.employee.photo')}}</h3>
                                                <input type="file"  ref="profile_image"  style="display:none" @input="showSelectedImage" accept="image/*">
                                                <img  :src="image" @click="$refs.profile_image.click()"
                                                class="img-responsive" style="cursor:pointer; max-width:200px; max-height:200px">
                                            </div>

                                            <div class="col-12">
                                                <label class="control-label" for="StatusID:">{{
                                                $t("form.student.status")
                                                }}</label>
                                                <v-select
                                                label="Name"
                                                :options="statusList"
                                                v-model="staff.Status"
                                                :reduce="status => status.id"
                                                >
                                                </v-select>
                                            </div>
                                        </div>

                                        <div class="col-md-9 col-sm-8">
                                            <div class="form-group">
                                                <label>{{$t('form.employee.title')}}</label>
                                                <v-select :options="titles" v-model="staff.Title"
                                                    :reduce="titles => titles">
                                                </v-select>
                                            </div>

                                            <div class="form-group">
                                                <label>
                                                    {{$t('form.employee.firstName')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <input type="text" class="form-control"
                                                    :class="{ 'is-invalid': $v.staff.FirstName.$error }"
                                                    v-model.trim="$v.staff.FirstName.$model">
                                                <div class="invalid-feedback" v-if="!$v.staff.FirstName.required">
                                                    {{$t('form.validation.required')}}</div>
                                                <div class="invalid-feedback" v-if="!$v.staff.FirstName.maxLength">
                                                    {{$t('form.validation.maxLength', {num: $v.staff.FirstName.$params.maxLength.max})}}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label>
                                                    {{$t('form.employee.lastName')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <input type="text" class="form-control"
                                                    v-model.trim="$v.staff.LastName.$model"
                                                    :class="{ 'is-invalid': $v.staff.LastName.$error }">
                                                <div class="invalid-feedback" v-if="!$v.staff.LastName.required">
                                                    {{$t('form.validation.required')}}
                                                </div>
                                                <div class="invalid-feedback" v-if="!$v.staff.LastName.maxLength">
                                                    {{$t('form.validation.maxLength', {num: $v.staff.LastName.$params.maxLength.max})}}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label>
                                                    {{$t('form.employee.birthDate')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <!-- <input v-model="staff.BirthDate" type="date" class="form-control"
                                                    :class="{ 'is-invalid': $v.staff.BirthDate.$error }"
                                                    v-model.trim="$v.staff.BirthDate.$model"> -->
                                                <div class="invalid-feedback" v-if="!$v.staff.BirthDate.required">
                                                    {{$t('form.validation.required')}}
                                                </div>

                                                <date-picker
                                                class="date-picker"
                                                v-model="staff.BirthDate"
                                                valueType="format"
                                                :format="dateFormat"
                                                :popup-style="{
                                                  top: '100%',
                                                  left: 0,
                                                }"
                                                :append-to-body="false"
                                                :placeholder="staff.BirthDate"
                                              >
                                              </date-picker>

                                            </div>

                                            <div class="form-group">
                                                <label>
                                                    {{$t('form.employee.birthPlace')}}
                                                    <span class="req text-danger">*</span>
                                                </label>
                                                <input type="text" v-model.trim="$v.staff.BirthPlace.$model"
                                                    class="form-control"
                                                    :class="{ 'is-invalid': $v.staff.BirthPlace.$error }">
                                                <div class="invalid-feedback" v-if="!$v.staff.BirthPlace.required">
                                                    {{$t('form.validation.required')}}
                                                </div>
                                                <div class="invalid-feedback" v-if="!$v.staff.BirthPlace.maxLength">
                                                    {{$t('form.validation.maxLength', {num: $v.staff.BirthPlace.$params.maxLength.max})}}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label>{{$t('form.employee.birthCountry')}}</label>
                                                <v-select label="printable_name" :options="countries"
                                                    v-model="staff.BirthCountry"
                                                    :reduce="countries => countries.printable_name">
                                                </v-select>
                                            </div>

                                            <div class="form-group">
                                                <label>{{$t('form.employee.department')}}</label>
                                                <v-select :options="departments" v-model="staff.Department"
                                                    :reduce="departments => departments">
                                                </v-select>
                                            </div>

                                            <div class="form-group">
                                                <label>{{$t('form.employee.position')}}</label>
                                                <v-select :options="positions" v-model="staff.Position"
                                                    :reduce="positions => positions">
                                                </v-select>
                                            </div>

                                            <div class="form-group">
                                                <label>
                                                    {{$t('form.employee.streetAddress')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <input type="text" v-model.trim="$v.staff.StreetAddress.$model"
                                                    class="form-control"
                                                    :class="{ 'is-invalid': $v.staff.StreetAddress.$error }">
                                                <div class="invalid-feedback" v-if="!$v.staff.StreetAddress.required">
                                                    {{$t('form.validation.required')}}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label>
                                                    {{$t('form.employee.city')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <input type="text" v-model.trim="$v.staff.City.$model"
                                                    class="form-control"
                                                    :class="{ 'is-invalid': $v.staff.City.$error }">
                                                <div class="invalid-feedback" v-if="!$v.staff.City.required">
                                                    {{$t('form.validation.required')}}</div>
                                                <div class="invalid-feedback" v-if="!$v.staff.City.maxLength">
                                                    {{$t('form.validation.maxLength', {num: $v.staff.City.$params.maxLength.max})}}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label>
                                                    {{$t('form.employee.zip')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <input type="text" v-model.trim="$v.staff.Zip.$model"
                                                    class="form-control" :class="{ 'is-invalid': $v.staff.Zip.$error }">
                                                <div class="invalid-feedback" v-if="!$v.staff.Zip.required">
                                                    {{$t('form.validation.required')}}</div>
                                                <div class="invalid-feedback" v-if="!$v.staff.Zip.maxLength">
                                                    {{$t('form.validation.maxLength', {num: $v.staff.Zip.$params.maxLength.max})}}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label>{{$t('form.employee.country')}}<span
                                                        class="text-danger">*</span></label>
                                                <v-select label="printable_name" :options="countries"
                                                    v-model.trim="$v.staff.Country.$model"
                                                    :reduce="countries => countries.printable_name">
                                                </v-select>
                                                <div class="invalid-feedback custom-validate" v-if="invalidCountry">
                                                    {{$t('form.validation.required')}}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label for="PhoneField">{{$t('form.employee.phone')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <div class="d-flex align-items-center">
                                                    <input type="text" id="PhoneField"
                                                        v-model.trim="$v.staff.Phone.$model" class="form-control"
                                                        :class="{ 'is-invalid': $v.staff.Phone.$error }">
                                                    <a :href="`tel:${staff.Phone}`"
                                                        class="btn btn-default text-nowrap">{{$t('button.call')}}</a>
                                                </div>
                                                <div class="invalid-feedback d-block" v-if="!$v.staff.Phone.required">
                                                    {{$t('form.validation.required')}}</div>
                                                <div class="invalid-feedback d-block" v-if="!$v.staff.Phone.maxLength">
                                                    {{$t('form.validation.maxLength', {num: $v.staff.Phone.$params.maxLength.max})}}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label for="MobileField">
                                                    {{$t('form.employee.mobile')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <div class="d-flex align-items-center">
                                                    <input type="text" id="MobileField"
                                                        v-model.trim="$v.staff.Mobile.$model" class="form-control"
                                                        :class="{ 'is-invalid': $v.staff.Mobile.$error }">
                                                    <a :href="`tel:${staff.Mobile}`"
                                                        class="btn btn-default text-nowrap">{{$t('button.call')}}</a>
                                                </div>
                                                <div class="invalid-feedback d-block" v-if="!$v.staff.Mobile.required">
                                                    {{$t('form.validation.required')}}
                                                </div>
                                                <div class="invalid-feedback d-block" v-if="!$v.staff.Mobile.maxLength">
                                                    {{$t('form.validation.maxLength', {num: $v.staff.Mobile.$params.maxLength.max})}}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label for="EmailField">
                                                    {{$t('form.employee.email')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <div class="d-flex align-items-center">
                                                    <input type="email" id="EmailField"
                                                        v-model.trim="$v.staff.Email.$model" class="form-control"
                                                        :class="{ 'is-invalid': $v.staff.Email.$error }">
                                                    <a :href="`mailto:${staff.Email}`"
                                                        class="btn btn-default text-nowrap">{{$t('button.email')}}</a>
                                                </div>
                                                <div class="invalid-feedback d-block" v-if="!$v.staff.Email.required">
                                                    {{$t('form.validation.required')}}
                                                </div>
                                                <div class="invalid-feedback d-block" v-if="!$v.staff.Email.email">
                                                    {{$t('form.validation.validEmail')}}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label for="Email2Field">{{$t('form.employee.email2')}}</label>
                                                <div class="d-flex">
                                                    <input id="Email2Field" name="Email2" v-model="staff.Email2"
                                                        type="text" class="form-control">
                                                    <a :href="`mailto:${staff.Email2}`"
                                                        class="btn btn-default text-nowrap">{{$t('button.email')}}</a>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label for="Email3Field">{{$t('form.employee.email3')}}</label>
                                                <div class="d-flex">
                                                    <input id="Email3Field" name="Email3" v-model="staff.Email3"
                                                        type="text" class="form-control">
                                                    <a :href="`mailto:${staff.Email3}`"
                                                        class="btn btn-default text-nowrap">{{$t('button.email')}}</a>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label>{{$t('form.employee.webAddress')}}</label>
                                                <input v-model="staff.WebAddress" class="form-control">
                                            </div>
                                        </div>

                                    </div>
                                </b-tab>

                                <b-tab :title="$t('form.employee.tabContracts')" v-if="isOwner || isHR || isAdmin">
                                      <Contracts :readonly="readonly" :removeContract="removeContract" :downloadContract="downloadContract" :contractDropzone="contractDropzone" :contractUploaded="contractUploaded" :uploadFileError="uploadFileError" :contracts="contracts" :getAttachmentFileName="getAttachmentFileName" />
                                </b-tab>

                                <b-tab :title="$t('form.student.tabAttachment')">
                                     <attachments :readonly="readonly" :isLoading="isLoading" :attachments="attachments" :downloadAttachment="downloadAttachment" :removeAttachment="removeAttachment" :attachmentUploaded="attachmentUploaded" :uploadFileError="uploadFileError" :attachmentDropzone="attachmentDropzone" :getAttachmentFileName="getAttachmentFileName"/>
                                </b-tab>

                                <b-tab :title="$t('form.employee.tabAbsence')" v-if="isSBSOwner || isSBSHR || isAdmin">
                                    <div class="row">
                                        <div class="form-group col-md-6">
                                            <label> {{$t('form.employee.vacationBalance')}} </label>
                                            <input type="text" class="form-control"
                                                v-model.trim="$v.staff.VacationBalancePerYear.$model"
                                                :class="{ 'is-invalid': $v.staff.VacationBalancePerYear.$error }"
                                                :disabled="!isSBSHR && !isAdmin">
                                            <div class="invalid-feedback"
                                                v-if="!$v.staff.VacationBalancePerYear.integer">
                                                {{$t('form.validation.integerAllowed')}}
                                            </div>

                                            <label> {{$t('form.employee.workload')}} </label>
                                            <input type="text" class="form-control"
                                                v-model.trim="$v.staff.Workload.$model"
                                                :class="{ 'is-invalid': $v.staff.Workload.$error }"
                                                :disabled="!isSBSHR && !isAdmin">
                                            <div class="invalid-feedback"
                                                v-if="!$v.staff.Workload.integer">
                                                {{$t('form.validation.integerAllowed')}}
                                            </div>
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label>{{$t('form.employee.totalVacationBalance')}}</label>
                                            <input type="text" class="form-control" v-model="staff.TotalVacationBalance"
                                                disabled>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-12">
                                            <hr>
                                        </div>

                                        <div class="col-md-6">
                                            <b-card :header="$t('form.employee.vacationBalanceAdjustment')"
                                                header-bg-variant="light" body-class="p-0">
                                                <template v-if="adjustmentsList.length > 0">
                                                    <b-table hover :items="adjustmentsList" :fields="adjustmentFields">
                                                        <template v-slot:cell(created_at)="data">
                                                            {{ data.value | formatDate(dateFormat) }}
                                                        </template>
                                                    </b-table>

                                                    <pagination v-if="adjustmentPagination.last_page > 1"
                                                        :pagination="adjustmentPagination" :offset="5"
                                                        @paginate="paginate()" :onlyDirectional="true">
                                                    </pagination>
                                                </template>

                                                <p class="p-3" v-else>{{$t('noRecord')}}</p>
                                            </b-card>
                                        </div>

                                        <div class="col-md-6" v-if="isSBSHR || isAdmin">
                                            <b-card :header="$t('form.employee.vacationBalanceAdjustmentAdd')"
                                                header-bg-variant="light">
                                                <b-form @submit.stop.prevent="addAdjustment">
                                                    <b-form-group id="input-group-1"
                                                        :label="$t('form.employee.vacationType')" label-for="input-1">
                                                        <b-form-input id="input-1" v-model="$v.adjustment.type.$model"
                                                            :state="validateState('type')"
                                                            aria-describedby="input-1-live-feedback">
                                                        </b-form-input>
                                                        <b-form-invalid-feedback id="input-1-live-feedback">
                                                            {{$t('form.validation.required')}}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>

                                                    <b-form-group id="input-group-2"
                                                        :label="$t('form.employee.vacationDay')" label-for="input-2">
                                                        <b-form-input id="input-2"
                                                            v-model.trim="$v.adjustment.days.$model"
                                                            :state="validateState('days')"
                                                            aria-describedby="input-2-live-feedback">
                                                        </b-form-input>
                                                        <b-form-invalid-feedback id="input-2-live-feedback">
                                                            {{$t('form.validation.requiredGreater')}}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>

                                                    <b-form-group>
                                                        <b-form-radio v-model="adjustment.mode" value="+">
                                                            {{$t('form.employee.vacationAdd')}}</b-form-radio>
                                                        <b-form-radio v-model="adjustment.mode" value="-">
                                                            {{$t('form.employee.vacationSub')}}</b-form-radio>
                                                    </b-form-group>

                                                    <b-form-group id="textarea"
                                                        :label="$t('form.employee.vacationRemark')"
                                                        label-for="textarea">
                                                        <b-form-textarea id="textarea"
                                                            v-model.trim="$v.adjustment.remarks.$model" rows="5"
                                                            max-rows="8" :state="validateState('remarks')"
                                                            aria-describedby="textarea-live-feedback">
                                                        </b-form-textarea>
                                                        <b-form-invalid-feedback id="textarea-live-feedback">
                                                            {{$t('form.validation.required')}}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>

                                                    <b-button type="submit" variant="primary">{{$t('button.add')}}
                                                    </b-button>
                                                    <b-button variant="default" @click="onAdjustmentReset">
                                                        {{$t('button.reset')}}
                                                    </b-button>
                                                </b-form>
                                            </b-card>
                                        </div>
                                    </div>
                                </b-tab>

                                <b-tab :title="$t('form.employee.tabAudit')">
                                    <b-table id="my-table" :items="audits" :per-page="perPageAudits" sort-by="date"
                                        :sort-desc="true" :current-page="currentPage" :fields="fields" small hover
                                        bordered responsive>
                                    </b-table>

                                    <b-pagination v-if="totalAudits" v-model="currentPage" :total-rows="totalAudits"
                                        :per-page="perPageAudits" aria-controls="my-table" align="center" pills>
                                    </b-pagination>
                                </b-tab>
                            </b-tabs>
                        </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import vue2Dropzone from "vue2-dropzone";
    import Attachments from './components/Attachments';
    import Contracts from './components/Contracts';
    import {
        required,
        minLength,
        maxLength,
        email,
        integer,
        numeric,
        decimal,
        minValue
    } from "vuelidate/lib/validators";

    export default {
        props: ['permissions', 'user', 'editFormInterval', 'dateFormat', 'datetimeFormat'],

        components: {
            vueDropzone: vue2Dropzone, Attachments, Contracts
        },

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                invalidCountry: false,
                image: '/images/default.jpg',

                interval: '',
                disableEditFormMessage: '',
                disableEditForm: false,

                showDisableAlert: false,
                firstLoad:true,
                sessionCreated:true,
                continueInterVal:true,
                closing: true,
                updated : true,

                adjustmentPagination: {
                    current_page: 1
                },

                // audits custom pagination
                currentPage: 1,
                perPageAudits: 5,
                fields: ['field', 'oldValue', 'newValue', 'userName', 'createdAt'],

                avatarDropzoneOptions: {
                    url: "/api/staff/profile-image",
                    headers: {
                        "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]")
                            .content,
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                    thumbnailWidth: 150,
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    maxFiles: 1
                },

                contractDropzone: {
                    url: "/api/staff/contracts/add",
                    headers: {
                        "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]")
                            .content,
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150
                },

                attachmentDropzone: {
                    url: "/api/staff/attachments/add",
                    headers: {
                        "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]")
                            .content,
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150
                },

                staff: {
                    FirstName: null,
                    LastName: null,
                    Title: null,
                    BirthDate: null,
                    BirthPlace: null,
                    BirthCountry: null,
                    StreetAddress: null,
                    City: null,
                    Zip: null,
                    Country: null,
                    Phone: null,
                    Mobile: null,
                    Fax: null,
                    Email: null,
                    Email2: null,
                    Email3: null,
                    WebAddress: null,
                    Photo: null,
                    Department: null,
                    Position: null,
                    VacationBalancePerYear: 0,
                    TotalVacationBalance: null,
                    Workload :0,
                    Status:null,
                },

                status: {
                    id: "",
                    Name: "",
                },

                adjustment: {
                    staff_id: null,
                    type: null,
                    mode: '+',
                    days: null,
                    remarks: null,
                },

                adjustmentFields: [{
                        key: 'created_at',
                        label: this.$t('form.employee.vacationDate')
                    },
                    {
                        key: 'user.name',
                        label: this.$t('form.employee.vacationOwner')
                    },
                    {
                        key: 'type',
                        label: this.$t('form.employee.vacationType')
                    },
                    {
                        key: 'days',
                        label: this.$t('form.employee.vacationDay')
                    },
                    {
                        key: 'remarks',
                        label: this.$t('form.employee.vacationRemark')
                    }
                ],

                titles: [],
                departments: [],
                positions: [],
                statusList: [],
                countries: [],
                contracts: [],
                attachments: [],
                audits: [],
                adjustmentsList: []
            }
        },

        validations: {
            staff: {
                FirstName: {
                    required,
                    maxLength: maxLength(100)
                },
                LastName: {
                    required,
                    maxLength: maxLength(100)
                },

                BirthPlace: {
                    required,
                    maxLength: maxLength(100)
                },
                BirthDate: {
                    required
                },
                StreetAddress: {
                    required
                },
                City: {
                    required,
                    maxLength: maxLength(100)
                },
                Country: {
                    required
                },
                Zip: {
                    required,
                    maxLength: maxLength(50)
                },
                Phone: {
                    required,
                    maxLength: maxLength(100)
                },
                Mobile: {
                    required,
                    maxLength: maxLength(100)
                },
                Email: {
                    required,
                    email
                },
                VacationBalancePerYear: {
                    integer
                },
                Workload: {
                    integer
                }
            },
            adjustment: {
                type: {
                    required,
                },
                days: {
                    required,
                    decimal,
                    minValue: minValue(0.5)
                },
                remarks: {
                    required
                }
            }
        },

        async mounted() {
            if (!this.permissions.viewEmployeeStaff) {
                this.$router.push("/");
                return;
            }

            await this.getInitialData();
            await this.getStaff();
            this.getAudits();

            if (this.permissions.editEmployeeStaff || this.user.staff_id == this.staff.ID) {
                this.checkForEdit();
                let self = this;
                  this.interval = setInterval(() => {
                    if(self.continueInterVal)
                    self.checkForEdit();
                    }, this.editFormInterval);

            }
        },

        computed: {
            totalAudits() {
                return this.audits.length
            },

            isAdmin() {
                if (this.user.roles) {
                    let found = this.user.roles.find(role => role.slug == 'admin');

                    if (found) return true;
                }

                return false;
            },

            isHR() {
                if (this.user.roles) {
                    let found = this.user.roles.find(role => role.slug == 'hr');

                    if (found) return true;
                }

                return false;
            },

            isSBSHR() {
                if (this.user.partner_id !== 1) {
                    return false;
                }

                if (this.user.roles) {
                    let found = this.user.roles.find(role => role.slug == 'hr');

                    if (found) return true;
                }

                return false;
            },

            isSBSOwner() {
                if (this.user.partner_id !== 1) {
                    return false;
                }

                if (this.user.staff_id) {
                    return this.user.staff_id == this.$route.params.id;
                }

                return false;
            },

            isOwner() {
                if (this.user.staff_id) {
                    return this.user.staff_id == this.$route.params.id;
                }

                return false;
            },

            readonly() {
                return !(this.permissions.editEmployeeStaff || this.user.staff_id == this.staff.ID);
            }
        },

        watch: {
            staff: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            },

            contracts: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            },

            attachments: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            }
        },

        methods: {

            /**
             * Get list of manual
             * vacation balance adjustments
             */
            getAdjustments() {
                axios
                    .get(
                        `/api/vacation-balance?staff_id=${this.staff.ID}&page=${this.adjustmentPagination.current_page}`
                    )
                    .then(response => {
                        this.adjustmentsList = response.data.data.data;
                        this.adjustmentPagination = response.data.pagination;
                    })
                    .catch(error => {
                        console.log('error fetching vacation balance');
                    });
            },

            /**
             * Validate manual adjustment form data
             */
            validateState(name) {
                const {
                    $dirty,
                    $error
                } = this.$v.adjustment[name];

                return $dirty ? !$error : null;
            },

            /**
             * Add Manual adjustment
             */
            addAdjustment() {
                this.$v.adjustment.$touch();
                if (this.$v.adjustment.$anyError) {
                    return;
                }

                this.clearAlert();
                this.isLoading = true;
                this.adjustment.staff_id = this.staff.ID;

                axios
                    .post('/api/vacation-balance', this.adjustment)
                    .then(response => {
                        if (response.data.success) {
                            this.showAlert(response.data.message);

                            this.adjustmentsList.unshift(response.data.data);
                            this.staff.TotalVacationBalance = response.data.data.staff.TotalVacationBalance;

                            this.getAudits();
                            this.onAdjustmentReset();
                            this.isLoading = false;
                        }
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.showAlert(error.response.data.message, 'danger');
                        }

                        this.isLoading = false;
                    })
            },

            async createToken(type = null) {
                let response = await axios.post('/api/api-tokens', {
                    type: `staff-${type}`,
                    staff: this.staff.ID
                });

                let token = '';

                if (response.status == 200) {
                    token = response.data.extra[0].token
                }

                return token;
            },


            async downloadAttachment(file , isDownload = false) {

                let token = await this.createToken('attachment');
                if (token == '') return;

                // Encode the file name to handle special characters
                let encodedFileName = encodeURIComponent(file.Name);
                let encodedFilePath = encodeURIComponent(file.File);

                window.open(`/staff/attachments/${encodedFileName}?${file.ID}&file=${encodedFilePath}&download=${isDownload}&token=${token}`, '_blank');

           },

            async downloadContract(file , isDownload = false) {
                let token = await this.createToken('contract');
                if (token == '') return;

                // Encode the file name to handle special characters
                let encodedFileName = encodeURIComponent(file.Name);
                let encodedFilePath = encodeURIComponent(file.File);

                window.open(`/staff/contracts/${encodedFileName}?${file.ID}&file=${encodedFilePath}&download=${isDownload}&token=${token}`, '_blank');
            },

            async getInitialData() {
                this.isLoading = true;

                await axios
                    .get("/api/staff/initial-data")
                    .then(response => {
                        this.isLoading = false;
                        
                        this.departments = response.data.departments;
                        this.positions = response.data.positions;
                        this.countries = response.data.countries;
                        this.titles = response.data.titles;
                        this.statusList = response.data.status;

                        this.perPageAudits = response.data.auditsPaginate;
                    })
                    .catch(error => {
                        console.log('error');
                        this.isLoading = false;
                    });
            },


              // show selecete image
            showSelectedImage(){

                 let input = this.$refs.profile_image
                let file = input.files
                if (file && file[0]) {
                let reader = new FileReader
                reader.onload = e => {
                    this.image = e.target.result
                }
                reader.readAsDataURL(file[0])
                this.$emit('input', file[0])
                }

                let fd = new FormData();
                fd.append('file',file[0]);
                this.isLoading = true;
                axios.post('/api/staff/profile-image',fd).then(resp=>{
                    this.staff.Photo = resp.data.filename;
                    this.isLoading = false;
                }).catch(error=>{
                    this.isLoading = false;
                    console.log('file not found');
                });
            },

            /**
             * Format Date
             */
            formatDate(format = "YYYY-MM-DD", date) {
                if (date) {
                    return moment(date).format(format);
                }
                return null;
            },

            getAttachmentFileName(file) {
                var file = file;
                if (typeof file === "string") {
                    return file.substring(file.lastIndexOf("/") + 1);
                } else {
                    return file;
                }
            },

            /**
             * Uploaded Contract Auto-save
             */
            contractUploaded(file, data) {
                this.loading = false;
                axios
                    .post("/api/staff/contract/file/save", {
                        Name: data.filename,
                        File: `${data.id}/${data.filename}`,
                        StaffID: this.staff.ID,
                        Description: "",
                        AttachmentDate: this.formatDate(),
                        UploadTimestamp:calculateTimeAsPerTimeZone('+2')
                    })
                    .then(response => {
                        if (response.data)
                        {
                            this.contracts.push({...response.data?.contract, Name:data.filename, type:file.type});
                            this.showAlert(response.data.message);
                            this.loading = false;
                        }
                    })
                    .catch(error =>
                    {
                        this.showAlert(error.response?.data?.message + ' '+  error.response?.data?.errors?.Name, "danger");
                        this.loading = false;
                    });
            },

            removeContract(index, attach) {
                let vm = this;

                console.log("remove contract");
                
                if (confirm(this.$t('form.validation.delete'))) {
                    axios
                        .post("/api/staff/contracts/remove", attach)
                        .then(response => {
                            this.showAlert(response.data.message)
                            vm.contracts.splice(index, 1);
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            },

            /**
             * Upload file error on dropzone
             */
            uploadFileError(file, message) {
                this.showAlert(message.errors, 'danger');
                this.isLoading = false;
            },

            /**
             * Uploaded Attachment Auto-save
             */
            attachmentUploaded(file, data) {
                this.loading = true;
                axios
                    .post("/api/staff/attachment/file/save", {
                        Name: data.filename,
                        File: `${data.id}/${data.filename}`,
                        StaffID: this.staff.ID,
                        Description: "",
                        AttachmentDate: this.formatDate(),
                        UploadTimestamp:calculateTimeAsPerTimeZone('+2')
                    })
                    .then(response => {
                        if (response.data)
                        {
                            this.attachments.push({...response.data?.attachment, Name:data.filename, type:file.type});
                            this.showAlert(response.data.message);
                            this.loading = false;
                        }
                    })
                    .catch(error =>
                    {
                        this.showAlert(error.response?.data?.message + ' '+  error.response?.data?.errors?.Name, "danger");
                        this.loading = false;
                    });
            },


            /**
             * Remove attachmemnt from student attachment list
             */
            removeAttachment(index, attach) {
                let vm = this;

                if (confirm(this.$t('form.validation.delete'))) {
                    axios
                        .post("/api/staff/attachments/remove", attach)
                        .then(response => {

                            if (response.data.error) {
                                this.showAlert(response.data.message, 'warning');
                            } else if (response.data.success) {
                                vm.attachments.splice(index, 1);
                                this.showAlert(response.data.message);
                            }

                        })
                        .catch(error => {
                            if (error.response && error.response.status === 403) {
                                this.showAlert(error.response.data.message, "warning");
                            } else {
                                console.log("error", error);
                            }
                        });
                }
            },

            async getStaff() {
                this.isLoading = true;

                await axios
                    .get("/api/staff/" + this.$route.params.id + '/edit')
                    .then(response => {
                        // this.isLoading = false;

                        this.staff = response.data.staff;
                        this.staff.BirthDate = this.staff.BirthDate
        ? moment(this.staff.BirthDate).format(this.dateFormat)
        : this.staff.BirthDate;

                        if (this.staff.Photo) {
                            this.getImage(`/api/staff/${this.$route.params.id}/profile-image`);
                        }

                        // Contracts
                        if (response.data.contracts.length) {
                            this.contracts = [];
                            response.data.contracts.map(contract => {
                                let c = contract;
                                c.Name = this.getAttachmentFileName(c.File);
                                c.UploadTimestamp = c.UploadTimestamp ? moment(c.UploadTimestamp).format(this.datetimeFormat) : null;
                                this.contracts.push(c);
                            });
                        }

                        // Attachments
                        if (response.data.attachments.length != 0) {
                            this.attachments = [];

                            response.data.attachments.map(attach => {
                                let a = attach;
                                a.Name = this.getAttachmentFileName(a.File);
                                a.UploadTimestamp = a.UploadTimestamp ? moment(a.UploadTimestamp).format(this.datetimeFormat) : null;

                                this.attachments.push(a);
                            });
                        }

                        if (this.isAdmin || this.isSBSHR || this.isSBSOwner)
                            this.getAdjustments();

                        setTimeout(() => {
                            this.isLoading = false;
                            this.closing = true;
                        }, 3000);
                    })
                    .catch(error => {
                        console.log('error');
                        this.isLoading = false;
                    });
            },

            getAudits() {
                axios
                    .get(`/api/staff/${this.$route.params.id}/audits`)
                    .then(response => {
                        this.audits = response.data;
                        this.audits.map(audit => {
                            audit.date = audit.createdAt;
                            audit.createdAt = moment(audit.createdAt).format(this.datetimeFormat);
                        });
                    })
                    .catch(error => {
                        console.log('error');
                    });
            },

            paginate() {
                this.getAdjustments();
            },


            checkForEdit(refresh = false) {

                    if(refresh)
                    this.continueInterVal = true;
                    let data= {
                        'field_id':this.$route.params.id,
                        'form':this.$route.name,
                        'refresh':refresh,
                    }
                    // if(refresh) this.showDisableAlert = false;
                    axios
                    .post("/api/check-for-edit-session" , data)
                    .then(response => {

                        this.sessionCreated = true;
                        if (response.data.warning == 0) {

                            this.disableEditForm = false;
                            this.showDisableAlert = false;
                            if(this.firstLoad)
                            {
                                this.firstLoad = false;
                                // this.getStaff();
                            }
                        }

                        if (response.data.warning == -1) {
                            this.disableEditForm = false ;
                            this.showDisableAlert = false;
                        }

                        if (response.data.warning == 1) {
                             this.firstLoad = false;
                            this.disableEditFormMessage = response.data.message;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                            this.continueInterVal = false;
                        }

                        if (response.data.warning == 2) {
                            let msg = response.data.message;
                            if(this.firstLoad){
                              msg.replace('re-open' ,'open');
                            }
                            this.sessionCreated = false;
                            this.disableEditFormMessage = msg;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                        }
                        if (response.data.warning == 3) {
                            this.disableEditForm = false;
                            this.showDisableAlert = true;
                            this.disableEditFormMessage = response.data.message;
                        }
                    })
                    .catch(error => {
                        console.log('error');
                    })
            },

            updateStaff(shouldClose = false) {
                this.$v.staff.$touch();

                if (this.disableEditForm) return;

                this.invalidCountry = this.staff.Country == null ? true : false;

                if (this.$v.staff.$invalid) {
                    let errorMsg = '';

                    if(this.$v.staff.FirstName.$error){
                            errorMsg = this.$t('form.employee.firstName');
                      }

                     if(this.$v.staff.LastName.$error){
                            errorMsg =  errorMsg ? errorMsg+', '+this.$t('form.employee.lastName'): this.$t('form.employee.lastName');
                      }

                    if(this.$v.staff.Email.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.email'): this.$t('form.employee.email');
                      }

                    if(this.$v.staff.BirthPlace.$error){
                            errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.birthPlace'): this.$t('form.employee.birthPlace');
                      }

                    if(this.$v.staff.BirthDate.$error){
                           errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.birthDate'): this.$t('form.employee.birthDate');
                      }

                    if(this.$v.staff.StreetAddress.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.streetAddress'): this.$t('form.employee.streetAddress');
                      }

                        
                        if(this.$v.staff.City.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.city'): this.$t('form.employee.city');
                      }

                        if(this.$v.staff.Country.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.country'): this.$t('form.employee.country');
                      }

                    if(this.$v.staff.Zip.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.zip'): this.$t('form.employee.zip');
                      }

                    if(this.$v.staff.Mobile.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.mobile'): this.$t('form.employee.mobile');
                      }
                    
                    if(this.$v.staff.Phone.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.phone'): this.$t('form.employee.phone');
                      }

                   
                    if(this.$v.staff.VacationBalancePerYear.$error){

                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.vacationBalance'): this.$t('form.employee.vacationBalance');
                      
                    }
                    if(this.$v.staff.Workload.$error){

                    errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.workload'): this.$t('form.employee.workload');

                    }

                    if(this.$v.adjustment.type.$error){

                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.vacationType'): this.$t('form.employee.vacationType');
                      
                    }

                     if(this.$v.adjustment.days.$error){

                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.vacationDay'): this.$t('form.employee.vacationDay');
                      
                    }
                    
                    if(this.$v.adjustment.remarks.$error){

                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.vacationRemark'): this.$t('form.employee.vacationRemark');
                      
                    }



                    this.showAlert(this.$t('form.validation.mandatoryFieldsError', {errors:errorMsg}), 'danger');

                    return; 
                }

                if (this.staff.VacationBalancePerYear == '')
                    this.staff.VacationBalancePerYear = 0;
                if (this.staff.Workload == '')
                    this.staff.Workload = 0;

                this.isLoading = true;
                let bDate= this.staff.BirthDate;
                // Convert input date string to moment object and format to "YYYY-MM-DD" format
                this.staff.BirthDate = moment(this.staff.BirthDate, "DD.MM.YYYY").format("YYYY-MM-DD");
                let contracts = [];
                let attachments = [];

                this.contracts.forEach(attach => contracts.push(JSON.stringify(attach)));
                this.attachments.forEach(attach => attachments.push(JSON.stringify(attach)));

                let data = {
                    staff: JSON.stringify(this.staff),
                    contracts: contracts,
                    attachments: attachments,
                };

                axios
                    .put("/api/staff/" + this.$route.params.id, data)
                    .then(response => {
                        this.isLoading = false;
                        this.closing = true;
                        this.updated = true;
                        if (response.data.success) {

                            this.showAlert(response.data.message);

                               if (shouldClose) {
                                    clearInterval(this.interval);
                                    setTimeout(() => this.$router.go(-1), 2000);
                                    return;
                                }
                                
                                /* If update only*/
                                this.contracts = [];
                                this.attachments = [];
                                
                                response.data.contracts.forEach(contract =>
                                {
                                    let c = contract;
                                    c.Name = this.getAttachmentFileName(c.File);
                                    c.UploadTimestamp = c.UploadTimestamp ? moment(c.UploadTimestamp).format(this.datetimeFormat) : null
                                    this.contracts.push(c);
                                });
                
            
                                response.data.attachments.forEach(attach => 
                                {
                                    let a = attach;
                                    a.Name = this.getAttachmentFileName(a.File);
                                    a.UploadTimestamp = a.UploadTimestamp ? moment(a.UploadTimestamp).format(this.datetimeFormat) : null
                                    this.attachments.push(a);
                                });
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            },

            /**
             * Clear alert message
             */
            clearAlert() {
                this.alertMessage = '';
                this.alertClass = '';
                this.alert = false;
            },

            /**
             * Clear manual adjustment form data
             */
            onAdjustmentReset() {
                // Reset our form values
                this.adjustment.type = null;
                this.adjustment.days = null;
                this.adjustment.mode = '+';
                this.adjustment.remarks = null;

                // Reset our form validation messages
                this.$v.adjustment.$reset();
            },

            // get student profile image
            getImage(url) {
                axios
                    .get(url, {
                        responseType: 'arraybuffer'
                    })
                    .then(response => {
                        this.image = this.imageEncode(response);
                    })
            },

            // encode image to base64
            imageEncode(response) {
                let arrayBuffer = response.data;
                let b64encoded = btoa([].reduce.call(new Uint8Array(arrayBuffer), (p, c) => p + String.fromCharCode(c),
                    ''))
                let mimetype = response.headers['content-type'].toLowerCase()

                return `data:${mimetype};base64,${b64encoded}`
            }
        },

        beforeRouteLeave(to, from, next) {
            if (this.closing || this.updated) {next();}
            else {
                const answer = window.confirm(this.$t('leavePrompt'))

                if (answer) {
                    next()
                } else {
                    next(false)
                }
            }
        }
    };

</script>

<style scoped>
    .custom-validate {
        display: block !important;
    }

</style>
